import { g as n } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as o, createElementBlock as l, normalizeClass as d, createElementVNode as a } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const u = {
  name: "DtIconAsana",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, m = ["aria-label", "data-qa", "aria-hidden"], f = ["fill"], p = ["id"];
function _(e, i, s, g, h, t) {
  return o(), l("svg", {
    "aria-label": s.ariaLabel,
    class: d([t.iconSizeClass, "d-icon d-icon--asana"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Asana",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("path", {
      d: "M17.65 12.787a4.35 4.35 0 1 0 0 8.699 4.35 4.35 0 0 0 0-8.7Zm-11.3 0a4.35 4.35 0 1 0 0 8.7 4.35 4.35 0 0 0 0-8.7Zm10-5.437a4.35 4.35 0 1 1-8.7 0 4.35 4.35 0 0 1 8.7 0Z",
      fill: `url(#${e.uniqueID}a)`
    }, null, 8, f),
    a("defs", null, [
      a("radialGradient", {
        id: `${e.uniqueID}a`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(13.2526 0 0 12.2495 12 13.103)"
      }, [...i[0] || (i[0] = [
        a("stop", { "stop-color": "#FFB900" }, null, -1),
        a("stop", {
          offset: ".6",
          "stop-color": "#F95D8F"
        }, null, -1),
        a("stop", {
          offset: ".999",
          "stop-color": "#F95353"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, m);
}
const D = /* @__PURE__ */ c(u, [["render", _]]);
export {
  D as default
};
//# sourceMappingURL=asana.js.map
